import React from "react";
import "./CompanyInvoiceList.css";

const CompanyInvoiceList = ({ title = "Invoices by Company", data = [] }) => {
  const maxValue = Math.max(...data.map((item) => item.value), 1);

  return (
    <div className="invoice-card">
      <h4 className="invoice-title">{title}</h4>

      <div className="invoice-list">
        {data.map((item, index) => {
          const percent = (item.value / maxValue) * 100;

          return (
            <div key={index} className="invoice-row">
              <div className="invoice-header">
                <span className="company-name">{item.name}</span>
                <span className="invoice-count">{item.value}</span>
              </div>

              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{ width: `${percent}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CompanyInvoiceList;